import { localisedPath } from 'common/url_locale_helper';

const signInForm = document.getElementById('new_spree_user');
const signUpButton = document.getElementById('signup__input');

if (signInForm && signUpButton) {
  signUpButton.addEventListener('click', () => {
    const passwordField = document.getElementById('spree_user_password');
    const emailField = document.getElementById('spree_user_email');
    if (emailField.value.length > 0) {
      passwordField.setAttribute('name', 'spree_user_create[password]');
      emailField.setAttribute('name', 'spree_user_create[email]');
      signInForm.setAttribute('action', localisedPath('/signup'));
    }
  });
}
